import type { TreeSpeciesOption } from '../../../../api/workshops';
import { fieldStyle } from '../../primitives';
import { Field } from '../../primitives/Field';
import { TWO_COLUMN_GRID } from '../../primitives/two-column-grid';

import {
  TREE_REPLACEMENT_LIMITS as LIMITS,
  type TreeReplacementFormErrors,
  type TreeReplacementFormValues,
} from './tree-replacement-form';
import { TreeReplacementContactFields } from './TreeReplacementContactFields';
import { TreeSpeciesSelect } from './TreeSpeciesSelect';

export interface TreeReplacementFormFieldsProps {
  values: TreeReplacementFormValues;
  errors: TreeReplacementFormErrors;
  onChange: (patch: Partial<TreeReplacementFormValues>) => void;
  /** Name and contact fields. */
  includeContact: boolean;
  storedSpecies?: TreeSpeciesOption | null;
}

export function TreeReplacementFormFields({
  values,
  errors,
  onChange,
  includeContact,
  storedSpecies = null,
}: TreeReplacementFormFieldsProps) {
  const state = (key: keyof TreeReplacementFormValues) => (errors[key] ? 'error' : undefined);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {includeContact && (
        <TreeReplacementContactFields values={values} errors={errors} onChange={onChange} />
      )}
      <div style={TWO_COLUMN_GRID}>
        <Field label="Trees" required error={errors.treeCount}>
          <input
            type="number"
            min={LIMITS.minTrees}
            max={LIMITS.maxTrees}
            step={1}
            value={values.treeCount}
            onChange={(e) => onChange({ treeCount: e.target.value })}
            style={fieldStyle(state('treeCount'))}
          />
        </Field>
        <TreeSpeciesSelect
          value={values.treeSpeciesId}
          storedSpecies={storedSpecies}
          error={errors.treeSpeciesId}
          onChange={(treeSpeciesId) => onChange({ treeSpeciesId })}
        />
      </div>
      <Field label="Notes" error={errors.staffNotes}>
        <textarea
          rows={3}
          value={values.staffNotes}
          maxLength={LIMITS.notes}
          onChange={(e) => onChange({ staffNotes: e.target.value })}
          style={fieldStyle(undefined, { height: 'auto', padding: '8px 10px', resize: 'vertical' })}
        />
      </Field>
    </div>
  );
}
